/** Tiny API client. Same-origin cookies + the CSRF header the server requires on state changes. */
export class ApiError extends Error {
  constructor(public status: number, public code: string, public details?: unknown) {
    super(code);
  }
}

export async function api<T>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? 'GET',
    credentials: 'same-origin',
    headers: { 'x-dg-csrf': '1', ...(init.body !== undefined ? { 'content-type': 'application/json' } : {}) },
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
  const data = res.status === 204 ? null : await res.json().catch(() => null);
  if (!res.ok) throw new ApiError(res.status, data?.error ?? 'error', data?.details);
  return data as T;
}

export interface Me {
  user: { email: string; name: string } | null;
  organization: { id: string; name: string };
  role: 'owner' | 'editor' | 'viewer';
  demo: { expiresAt: string; quoteUrl: string } | null;
}
